<template>
  <vk-offcanvas-content id="app">
    <app-header v-if="$route.path !== '/'" class="fix-position-box" id="layout-header"></app-header>
    <transition :name="transitionName">
      <router-view></router-view>
    </transition>

    <vk-notification class="notification" :timeout="2000"
                     :messages.sync="messages"
                     v-on:update:messages="updateMessage">
      <div slot-scope="{ message }">
        <span style="color:#FD9803" v-if="message==='お気に入り登録をしました'">★</span>
        <span style="color:#FD9803" v-if="message==='お気に入り登録を解除しました'">☆</span>
        {{message}}
      </div>
    </vk-notification>
    <spinner :show="loading">load</spinner>
  </vk-offcanvas-content>
</template>

<script>
  import AppHeader from './components/AppHeader.vue';
  import Spinner from './components/Spinner.vue';
  // import 'normalize.css';

  export default {
    name: 'app',
    components: {
      AppHeader,
      Spinner,
    },
    data() {
      return {
        transitionName: '',
      };
    },
    computed: {
      page() {
        return this.$store.state.page;
      },
      loading() {
        return this.$store.state.loading;
      },
      messages() {
        return this.$store.state.messages;
      },
    },
    created() {
      document.title = 'harigu';
      // お気に入りの重複を避けるためのユーザーID発行
      let userId = localStorage.getItem('userId');
      if (!userId) {
        userId = this.userId();
        localStorage.setItem('userId', userId);
      }
      // this.$router.push('/'); // スプラッシュ画面へ
    },
    methods: {
      updateMessage(messages) {
        this.$store.commit('setMessages', messages);
      },
      userId() {
        return 'Uxxxxxxx-xxxxxxxxxxxx'.replace(/[x]/g, function () {
          let r = Math.random() * 16 | 0;
          return r.toString(16);
        });
      },
    },
    watch: {
      '$route'(to, from) {
        if (from.path === '/') {
          this.transitionName = 'fade';
        } else {
          this.transitionName = '';
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .notification {
    top: 100px;
  }

  * {
    max-width: 445px;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }
</style>
<style>
  html {
    font-size: 16px !important;
  }
  body {
    min-height: 100vh;
  }
  #app, .main, .content {
    min-height: 100vh;
  }
</style>
